export default __webpack_public_path__ + "static/media/fioretto-charred-proscuitto-wrapped.b218d173.png";